// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { myListsDetailsOptionsStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsOptions";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { xScreen } from "@stanion/XDL/Utilities";
import { css } from "styled-components";

myListsDetailsOptionsStyles.productSelectorStyles = {
    searchGridItem: {
        width: [12, 12, 4, 5, 5],
        css: css`
            position: relative;
            align-items: center;
        `,
    },
    qtyGridItem: {
        width: [3, 3, 2, 1, 1],
        css: css`
            align-items: center;
        `,
    },
    unitOfMeasureGridItem: {
        width: [9, 9, 3, 3, 3],
        css: css`
            align-items: center;
        `,
    },
    clearIcon: {
        css: css`
            position: absolute;
            right: 40px;
            top: 33px;
            cursor: pointer;
        `,
    },
    selectButton: {
        css: css`
            margin-top: 20px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            width: 100%;
                        `,
                    ],
                    "max",
                )}
        `,
    },
};

myListsDetailsOptionsStyles.wrapper = {
    css: css`
            @media print {
                display: none;
            }
            display: flex;
            margin-bottom: 20px;
        `,
};

myListsDetailsOptionsStyles.rightColumnWrapper = {
    css: css`
        display: flex;
        width: 40px;
        justify-content: center;
        margin-top: 20px;
    `,
};

myListsDetailsOptionsStyles.container = {
    gap: 10,
    css: css`
        margin-top: 20px;
    `,
};

myListsDetailsOptionsStyles.uploadItemsGridItem = {
    width: [12, 12, 12, 2, 2],
    css: css`
        align-items: flex-start;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                null,
                null,
                css`
                    padding-top: 32px;
                `,
                css`
                    padding-top: 32px;
                `,
            ])}
    `,
};

myListsDetailsOptionsStyles.uploadItemsLink = {
    css: css`
        margin: 0;
    `,
};

myListsDetailsOptionsStyles.productSelectorStyles = {
    clearIcon: {
        css: css`
            position: absolute;
            right: 30px;
            top: 33px;
            cursor: pointer;
            ${xScreen("lte", "sm")} {
                top: 34px;
            }
        `,
    },
    searchDynamicDropdown: {
        cssOverrides: {
            selectedText: css`
                width: calc(100% - 45px);
            `,
        },
    },
};
